import Hero from "components/organisms/common/Hero"
import ImageUkHero from "components/atoms/schools/ImageUkHero"
import useTranslations from "hooks/useTranslations"
import { fillWithUtm } from "utils/url"
import { LOGIN_URL } from "../parentInfo/LoginButton"
import BookDemoButton from "./BookDemoButton"

/**
 * Mint hero, matching the UK sales deck's cover — the deck's mint is
 * rgb(96,202,178) and `kkm-green` resolves to rgb(91,200,180), so the brand
 * token already is the deck colour.
 *
 * The brand word is picked out in cream rather than underlined. Note that no
 * light colour can reach WCAG's 3:1 for large text against this mint — white
 * itself only manages 2:1 — so the emphasis here is carried by hue, with the
 * surrounding words in near-black doing the legibility work. That is the same
 * trade the site's yellow heroes already make with their white highlights.
 *
 * Not flipped. The children in the photo look down and to the left, which on
 * this layout points them back at the headline; mirroring them would have them
 * looking off the edge of the page.
 */

/**
 * Two CTAs side by side, on Kaisa's request: "Log in" for schools already
 * using SomeBuddy (the same somebuddy.help login as the Parent Info page),
 * then the trial booking. Login is outlined so the trial stays the primary
 * action; both share BookDemoButton's pill so they line up at one height.
 *
 * Module level rather than an inline arrow: Hero renders `Button` as a
 * component, and a new function each render would remount BookDemoButton and
 * drop its booker dialog state. Hero's bgStyle hint is ignored; both are dark.
 */
function HeroActions() {
  const { ukSchoolsHeroButton, buttonLogin } = useTranslations()

  return (
    <div className="flex flex-wrap gap-3 sm:justify-center lg:justify-start">
      <a
        href={fillWithUtm(LOGIN_URL)}
        target="_blank"
        rel="noopener noreferrer"
        className="pointer inline-block rounded-full border-2 border-solid border-zinc-800 bg-transparent px-6 py-3 text-center font-display text-base font-bold leading-snug text-zinc-900 no-underline transition duration-150 ease-in-out hover:bg-zinc-800 hover:text-white focus:outline-none focus-visible:ring-4 focus-visible:ring-zinc-500 active:scale-[0.96] lg:py-4"
      >
        {buttonLogin}
      </a>
      <BookDemoButton label={ukSchoolsHeroButton} bgStyle="black" />
    </div>
  )
}

export default function UkHero() {
  const {
    ukSchoolsHeroTitle,
    ukSchoolsHeroDescription,
    ukSchoolsHeroHighlight,
  } = useTranslations()

  return (
    <Hero
      Image={ImageUkHero}
      slides={[ukSchoolsHeroTitle]}
      description={ukSchoolsHeroDescription}
      bgColor="green"
      flipImage={false}
      searchWords={ukSchoolsHeroHighlight || [""]}
      highlightClassName="bg-transparent text-kkm-cream"
      Button={HeroActions}
    />
  )
}
